module.exports = __webpack_public_path__ + "media/Drug_Farm_Video.8fd8086f.mp4";